<template>
  <Modal>
    <Modal.Title>{{ title }}</Modal.Title>
    <Modal.Body>
      <p class="text-[14px] leading-[22px] text-gray-800">{{ body }}</p>
    </Modal.Body>
    <Modal.Footer layout="vertical">
      <Button
        variant="primary"
        :size="isMobile ? 'lg' : 'md'"
        @click="handleOkay"
      >
        {{ okayLabel || 'Okay' }}
      </Button>
    </Modal.Footer>
  </Modal>
</template>

<script setup lang="ts">
import { Modal, Button } from '@dacr/library'

import { useDevice } from '@/shared/composables/useDevice'
import { closeAllModals } from '@/shared/dialogs/modals'
import { closeAllSheets } from '@/shared/dialogs/sheets'

defineProps<{
  title: string
  body: string
  okayLabel?: string
}>()

const { isMobile } = useDevice()

const handleOkay = () => {
  closeAllModals()
  closeAllSheets()
}
</script>
